module.exports = __webpack_public_path__ + "img/bgPurple.8f7a8350.png";